import React, { forwardRef, useCallback } from 'react'
import { Button } from 'antd'

type CopyButtonProps = React.ComponentPropsWithRef<typeof Button> & {
  copyData: string | object
}

export const CopyButton: React.FC<CopyButtonProps> = forwardRef(({copyData, onClick, ...props}, ref) => {
  const handleClick: React.MouseEventHandler<HTMLElement> = useCallback(async (e) => {
    if (typeof copyData === 'string') {
      await navigator.clipboard.writeText(copyData)
    } else if (typeof copyData === 'object') {
      await navigator.clipboard.writeText(JSON.stringify(copyData, null, 2))
    }
    onClick?.(e)

  }, [copyData, onClick])
  return (
    <Button {...props} onClick={handleClick} ref={ref} />
  )
})
